import {
  BET_TYPE_DENOMINATION,
  DRAW_SCHEDULE,
  IEmployee,
  IPixKey,
  IUser,
  IWallet,
  ODD_TYPE,
  TLang,
  WALLET_CODE,
  WALLET_TYPE,
} from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';

export const setUser = createAction('[Auth] Set User', props<{ user: IUser }>());
export const setEmployee = createAction('[Auth] Set Employee', props<{ employee: IEmployee }>());
export const setAccessToken = createAction('[Auth] Set access_token', props<{ access_token: string }>());
export const addAvatarUrl = createAction('[Auth] Set avatar', props<{ url: string }>());
export const updateUserImageId = createAction('[Auth] Set umage id', props<{ image_id: string }>());
export const setCurrency = createAction('[Auth] Update User Currency', props<{ currency: IWallet }>());
export const updateUserLang = createAction('[Auth] Update User Settings', props<{ lang: TLang }>());
export const updateUserSchedule = createAction('[Auth] Update User Settings', props<{ schedule: DRAW_SCHEDULE }>());
export const updateEmployeeSchedule = createAction(
  '[Auth] Update Employee Settings',
  props<{ schedule: DRAW_SCHEDULE }>(),
);
export const updateUserCurrency = createAction('[Auth] Update User currency', props<{ code: WALLET_CODE }>());
export const updateUserWalletType = createAction(
  '[Auth] Update User wallet type',
  props<{ wallet_type: WALLET_TYPE }>(),
);
export const updatePixKey = createAction('[Auth] Update User pixkey', props<{ pixKey: IPixKey }>());
export const setUserBetTypeOdd = createAction(
  '[Auth] Update User bt && odd',
  props<{ bt: BET_TYPE_DENOMINATION; odd: ODD_TYPE }>(),
);
export const setUsername = createAction('[Auth] Update Username', props<{ username: string }>());
export const setUserEmail = createAction('[Auth] Update email', props<{ email: string }>());
export const addGameBookmark = createAction('[Auth] Add game bookmark', props<{ id: string }>());
export const removeGameBookmark = createAction('[Auth] Remove game bookmark', props<{ id: string }>());
export const setAvatarImage = createAction('[Auth] Set avatar image as _id');
